import { render, staticRenderFns } from "./studentCard.vue?vue&type=template&id=5c6cd997&scoped=true&"
import script from "./studentCard.vue?vue&type=script&lang=js&"
export * from "./studentCard.vue?vue&type=script&lang=js&"
import style0 from "./studentCard.vue?vue&type=style&index=0&id=5c6cd997&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6cd997",
  null
  
)

export default component.exports